/** What a host is told when somebody clicks a canvas it mounted for editing rather than for use. */

/** A rectangle in the surface's own coordinates, so a host can outline what was hit. */
export interface SelectBounds {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export interface SelectAction {
  /** The activity that drew what was hit, off the scene document it shipped. */
  readonly activityId: string;
  readonly canvasKind: string;
  /** The node under the pointer, or undefined for the document itself. */
  readonly nodeId: string | undefined;
  /** The drawn instance under the pointer, unique across repeats. Selection identity. */
  readonly nodeKey: string | undefined;
  readonly bounds: SelectBounds;
}

/** `play` submits, `select` reports. `play` is the default. */
export type SurfaceMode = "play" | "select";

/** One element's box in another's coordinates. */
export function boundsWithin(target: Element, surface: Element): SelectBounds {
  const hit = target.getBoundingClientRect();
  const base = surface.getBoundingClientRect();
  return { x: hit.x - base.x, y: hit.y - base.y, width: hit.width, height: hit.height };
}
